import { React, useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
// import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";

const splitContent = (sentence) => {
    const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
    const matches = sentence.matchAll(InlineMathRegex);
    let lastIndex = 0;
    const contentArray = [];
  
    for (const match of matches) {
        const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
        const restOfContent = sentence.substring(lastIndex, match.index);
    
        contentArray.push(restOfContent, InlineMathContent);
        lastIndex = match.index + match[0].length;
    }
  
    if (lastIndex < sentence.length) {
        contentArray.push(sentence.substring(lastIndex));
    }
  
    return <div>{contentArray}</div>;
};

const ProblemStatDescription = (props) => {
    const { auth } = useAuth();
    const [problemDescriptionView, setProblemDescriptionView] = useState([]);
    const [count, setCount] = useState();
    const [problemSolvingIndex, setProblemSolvingIndex] = useState('');
    const [errP, setErrP] = useState(false);
    const [showIndexFlag, setShowIndexFlag] = useState(false);
    const axiosPrivate = useAxiosPrivate();

    // const sentence = "정사각형의 안쪽으로 넓이가 정사각형의 <InlineMath>\\frac{9}{29}</InlineMath>인 정사각형을 <InlineMath>x^2 + y^2 </InlineMath> 그리세요.";

    // const containerStyle = {
    //     whiteSpace: 'nowrap',
    //     maxWidth: '1520px',
    // };

    const getProblemSolvingAnalysisIndex = async () => {
        let isMounted = true;
        const controller = new AbortController();

        try {
            const response = await axiosPrivate.get('/solve/evaluation/problem/personal/', {
                params: {
                    problemCode: props.problemId
                },
                signal: controller.signal
            });

            isMounted && response.data && setProblemSolvingIndex(response.data)
        } catch(err) {
            console.log(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const handleSolvingAnalysis = () => {
        let count = 1;
        setCount(count);
        setShowIndexFlag(true);
        getProblemSolvingAnalysisIndex();
    }

    useEffect (() => {
        let tempView = props.problemDescription && props.problemDescription.split(/<br>|\|/);
        // let tempView = props.problemDescription && props.problemDescription.split('<br>');
        setProblemDescriptionView(tempView);
    }, [props.problemDescription])

    // console.log("count: ", count);
    // console.log("index: ", problemSolvingIndex);
    // console.log("useStat: ", props.useStat);

    return(
        <div>
            {<div style={{fontSize:24,fontWeight:900, marginTop:"15px", marginBottom:"25px"}}>
                <div>
                    {props.problemTitle && splitContent(props.problemTitle)}
                </div>
            </div>}

            {props.problemPoem && <div style={{marginLeft:"5px"}}>
                {props.problemPoem.length > 1 && <div>
                        <p>수학과 시는 겉보기엔 다르지만, 내면에는 깊은 연결고리가 있습니다. 수학은 논리와 추론의 언어로 세상을 설명하고, 시는 함축과 은유의 언어로 감성을 표현합니다. 하지만 둘 다 제한된 형식 속에서 무한한 상상력을 펼친다는 공통점을 지닙니다. 수학의 간결한 공식은 시의 함축적인 언어처럼 진리를 담고 있으며, 시의 리듬과 운율은 수학의 정교한 구조처럼 아름다움을 선사합니다. 즉, 수학과 시는 각각 논리와 감성이라는 두 개의 날개로 인간의 지성과 감성을 풍요롭게 하는 예술이라 할 수 있습니다.</p>
                        <p>티프매쓰에서는 수학이 시가 되고, 시는 영감을 주고, 수학은 지성과 감성의 풍요로운 완성이 됩니다.</p>
                        <p>시를 감상하며 상상력과 직관력을 한껏 고양시켜 보세요.</p>
                </div>}
                <p><b>{props.problemPoemTitle !== undefined && props.problemPoemTitle !== "NaN" && splitContent(props.problemPoemTitle)}</b></p>
                {props.problemPoem.length > 1 && props.problemPoem.map(poem => {
                    return (
                        <div>{poem.trim().length>0 ? splitContent(poem) : <br/>}</div>
                        // <div>{poem}<br/></div>
                    )
                })}
            </div>}
            {props.problemPoem && <div style={{marginTop:"15px", marginLeft:"5px"}}>
                {props.problemPoem.length > 1 && <p><b>준비가 되었나요? 이제 문제를 풀어보세요.</b></p>}
            </div>}


            {<div style={{marginLeft:"5px", marginBottom:"15px"}}>
                {problemDescriptionView && problemDescriptionView.map(view => (
                    <div style={{marginBottom:"6px"}}>
                        {
                            view.includes("제목:")
                            ? <p style={{fontSize:16, fontWeight:700, marginBottom:"10px"}}>{view}</p>
                            : view.trim().length>0 ? splitContent(view) :""
                        }
                    </div>
                ))}
            </div>}
            {/* <div style={containerStyle}>
                {splitContent(sentence)}
            </div> */}
            {props.problemType != 3 && props.problemType != 5 && props.problemType != 6 && <div style={{marginLeft:"5px"}}>
                {props.maxPoint
                    ? props.useStat.myPoint
                        ? props.useStat.myPoint > 0
                            ? `이 문제를 풀어 얻은 가장 높은 포인트는 ${props.maxPoint}포인트 입니다. 회원님이 습득한 포인트는 ${props.useStat.myPoint}포인트 입니다. 다양한 방법으로 문제를 해결해 최고 포인트 기록을 경신하세요.`
                            : `이 문제를 풀어 얻은 가장 높은 포인트는 ${props.maxPoint}포인트 입니다. 다양한 방법으로 문제를 해결해 최고 포인트 기록을 경신하세요.`
                        : `이 문제를 풀어 얻은 가장 높은 포인트는 ${props.maxPoint}포인트 입니다. 다양한 방법으로 문제를 해결해 최고 포인트 기록을 경신하세요.`
                    : "문제를 풀어 최고 포인트 기록을 남겨주세요."
                }
            </div>}

            {props.problemType != 3 && props.problemType != 5 && props.problemType != 6 && <div style={{marginLeft:"5px"}}>
                {props.useStat
                    ? props.useStat.triedUsersNum === 0
                        ? "아무도 도전한 사람이 없습니다. 문제를 푸는 첫 번째 도전자가 되세요."
                        : props.useStat.successfulUserNum === 0 
                            ? `${props.useStat.triedUsersNum}명이 도전했으나 아직 문제를 풀어낸 사람이 아직 없습니다. 문제를 푸는 첫 번째 사용자가 되시기 바랍니다.`
                            : `${props.useStat.triedUsersNum}명이 도전해 ${props.useStat.successfulUserNum}명이 문제를 풀었습니다. 문제를 풀어낸 ${(props.useStat.successfulUserNum/props.useStat.triedUsersNum*100).toFixed(2)}%의 사용자와 같은 자리를 차지하세요.`
                    : "아무도 도전한 사람이 없습니다. 문제를 푸는 첫 번째 도전자가 되세요."
                }
            </div>}
        
            {props.problemType != 3 && props.problemType != 5 && props.problemType != 6 && <div style={{marginLeft:"5px"}}>
                {props.useStat.myTryNum && props.useStat.myTryNum !== 0
                    ? <div>회원님은 {props.useStat.myTryNum}번을 시도해 {props.useStat.mySuccessNum}번 문제를 풀어냈습니다.</div>
                    : null
                }
                {/* {props.trialno && <div>{auth?.username}님은 {props.trialno.trialno1}번을 시도해 {props.trialno.trialno2}번 문제를 풀어냈습니다. 
                마지막 시도는 {props.trialno.trialno4 === 1 ? (props.trialno.trialno5 <= 1 ? "틀리지 않고 바로 문제를 해결했습니다" : `${props.trialno.trialno5} 번만에 문제를 해결했습니다.`) : `${props.trialno.trialno5} 번을 시도했으나 문제를 풀지 못하고 마쳤습니다.`}</div>} */}
            </div>}

            {props.problemType != 3 && props.problemType != 5 && props.problemType != 6 && <div style={{marginLeft:"5px"}}>
                {props.useStat.mySuccessNum > 0 && <button className="button" onClick={() => handleSolvingAnalysis()}>
                    풀이 분석 정보 보기
                </button>}
                {showIndexFlag
                    ? <div>
                        <p style={{fontSize:16, fontWeight:700, marginTop:"15px", marginBottom:"10px"}}>
                            전체 그룹과의 비교
                        </p>
                        <p>회원님은 {props.useStat.myTryNum}번을 시도해 {props.useStat.mySuccessNum}번을 풀어내 {Math.round(props.useStat.mySuccessNum/props.useStat.myTryNum*10000)/100}%의 풀이 성공률을 기록하고 있습니다.</p>
                        <p>회원님을 제외한 사용자의 풀이 성공률은 {Math.round((props.useStat.totalSuccess-props.useStat.mySuccessNum)/(props.useStat.totalTry-props.useStat.myTryNum)*10000)/100}%로, {
                            Math.round(props.useStat.mySuccessNum/props.useStat.myTryNum*10000)/100-Math.round((props.useStat.totalSuccess-props.useStat.mySuccessNum)/(props.useStat.totalTry-props.useStat.myTryNum)*10000)/100>0 
                            ? <div>회원님의 풀이 성공률이 다른 사람의 풀이 성공률보다 {Math.round(props.useStat.mySuccessNum/props.useStat.myTryNum*10000)/100-Math.round((props.useStat.totalSuccess-props.useStat.mySuccessNum)/(props.useStat.totalTry-props.useStat.myTryNum)*10000)/100}% 포인트 높습니다.</div>
                            : <div>
                                {
                                    Math.round(props.useStat.mySuccessNum/props.useStat.myTryNum*10000)/100-Math.round((props.useStat.totalSuccess-props.useStat.mySuccessNum)/(props.useStat.totalTry-props.useStat.myTryNum)*10000)/100==0
                                    ? <div>회원님의 풀이 성공률은 다른 사람들의 풀이 성공률과 같습니다.</div>
                                    : <div>회원님의 풀이 성공률이 다른 사람의 풀이 성공률보다 {Math.round((props.useStat.totalSuccess-props.useStat.mySuccessNum)/(props.useStat.totalTry-props.useStat.myTryNum)*10000)/100-Math.round(props.useStat.mySuccessNum/props.useStat.myTryNum*10000)/100}% 포인트 낮습니다.</div>
                                }
                            </div>
                        }</p>
                        <p style={{fontSize:16, fontWeight:700, marginTop:"15px", marginBottom:"10px"}}>
                            문제 해결 리스트
                        </p>
                        <table style={{width:"100%", maxWidth:"700px"}}>
                            <thead style={{ backgroundColor: 'yellow', height:"37px" }}>
                                <tr>
                                    <th style={{minWidth:"70px", width:"15%"}}>일련번호</th>
                                    <th style={{minWidth:"300px", width:"64%"}}>풀이 시각</th>
                                    <th style={{minWidth:"100px", width:"21%"}}>성공전 실패 횟수</th>
                                </tr>
                            </thead>
                            <tbody>
                                {problemSolvingIndex.solveSummary && problemSolvingIndex.solveSummary.map((solve, index) => {
                                        return (
                                                <tr key={index} style={{ height:"37px", backgroundColor: index % 2 === 0 ? 'white' : 'lightgrey' }}>
                                                    <td>{index+1}</td>
                                                    <td>{solve.solvingTime}</td>
                                                    <td>{solve.continuous_failure_no}</td>
                                                </tr>
                                        )
                                })}
                            </tbody>
                        </table>
                        <p style={{fontSize:16, fontWeight:700, marginTop:"15px", marginBottom:"10px"}}>
                            수학 접근성 지수
                        </p>
                        <p>현재 보고 있는 문제의 풀이 정보를 기반으로 하여 이 문제에 관한 문제해결능력과 함께 익힘, 의지와 같은 태도를 지수화하여 나타낸 것입니다. 지수가 100이면 우수한 수준으로, 80이면 양호한 수준으로 볼 수 있습니다.</p>
                        {/* <div>문제해결능력: 창의적인 상상과 체계적인 구성, 정확한 구현을 통해 수학 문제를 스마트하게 다양한 방법으로 풀어내는 능력</div>
                        <div>익힘: 문제를 해결한 후 이를 다시 구성하며 정리하는 성실함을 나타내는 지수</div>
                        <div>의지: 문제 풀이 실패의 두려움을 극복하고 풀이의 어려움에 좌절하지 않고 문제를 해결해 내고 확인하는 의지를 나타내는 지수</div> */}
                        <table style={{width:"100%", maxWidth:"700px"}}>
                            <thead style={{ backgroundColor: 'yellow', height:"37px" }}>
                                <tr>
                                    <th style={{minWidth:"80px", width:"16%"}}>항목</th>
                                    <th style={{minWidth:"180px", width:"28%"}}>문제해결능력</th>
                                    <th style={{minWidth:"180px", width:"28%"}}>익힘</th>
                                    <th style={{minWidth:"180px", width:"28%"}}>의지</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ height:"37px", backgroundColor: 'lightgrey' }}>
                                    <td>지수</td>
                                    <td>{problemSolvingIndex.smartness}</td>
                                    <td>{problemSolvingIndex.exerciseFlag ? problemSolvingIndex.exercise : "산정 보류"}</td>
                                    <td>{problemSolvingIndex.willingnessFlag ? problemSolvingIndex.willingness : "산정 보류"}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div><b>문제해결능력</b>: 창의적인 상상과 체계적인 구성, 정확한 구현을 통해 수학 문제를 스마트하게 다양한 방법으로 풀어내는 능력</div>
                        <div><b>익힘</b>: 문제를 해결한 후 이를 다시 구성하며 정리하는 성실함을 나타내는 지수</div>
                        <div><b>의지</b>: 문제 풀이 실패의 두려움을 극복하고 풀이의 어려움에 좌절하지 않고 문제를 해결해 내고 확인하는 의지를 나타내는 지수</div>
                        {/* <ResponsiveContainer width="100%" height={400}>
                            <RadarChart data={chartData} cx="50%" cy="50%" outerRadius="80%">
                                <PolarGrid />
                                <PolarAngleAxis dataKey="subject" />
                                <PolarRadiusAxis domain={[0, 150]} />
                                <Radar
                                    name="점수"
                                    dataKey="score"
                                    stroke="#8884d8"
                                    fill="#8884d8"
                                    fillOpacity={0.6}
                                />
                            </RadarChart>
                        </ResponsiveContainer> */}
                        <p style={{fontSize:16, fontWeight:700, marginTop:"15px", marginBottom:"10px"}}>
                            인공지능을 활용한 데이터 분석
                        </p>
                        <p>다음 질문을 복사해 챗gpt, 제미나이, 딥시크, Perplexity, 클로그, Felo 등의 인공지능에 질문해 보세요. 주어진 데이터를 바탕으로 더 정확한 질문을 만들어 하게 되면 더 유용한 학습 자료를 습득할 수 있습니다.</p>
                        {problemSolvingIndex.exerciseFlag && problemSolvingIndex.willingnessFlag
                            ? <div>"100을 우수함, 80을 양호함의 기준으로 하여 수학 문제를 스마트하게 다양한 방법으로 풀어내는 문제해결능력 지수가 {problemSolvingIndex.smartness}이고, 문제를 여러 번 풀어보면서 풀이에 적용된 논리와 방법을 익히는 익힘 지수가 {problemSolvingIndex.exercise}이고, 문제가 어렵고 풀이에 실패하더라도 포기하지 않고 해결해내는 의지 지수가 {problemSolvingIndex.willingness}인 학습자에 대해 진단하고 적절한 제안을 해 줘요."</div>
                            : !problemSolvingIndex.exerciseFlag && problemSolvingIndex.willingnessFlag
                                ? <div>"100을 우수함, 80을 양호함의 기준으로 하여 수학 문제를 스마트하게 다양한 방법으로 풀어내는 문제해결능력 지수가 {problemSolvingIndex.smartness}이고, 문제가 어렵고 풀이에 실패하더라도 포기하지 않고 해결해내는 의지 지수가 {problemSolvingIndex.willingness}인 학습자에 대해 진단하고 적절한 제안을 해 줘요."</div>
                                : problemSolvingIndex.exerciseFlag && !problemSolvingIndex.willingnessFlag
                                    ? <div>"100을 우수함, 80을 양호함의 기준으로 하여 수학 문제를 스마트하게 다양한 방법으로 풀어내는 문제해결능력 지수가 {problemSolvingIndex.smartness}이고, 문제를 여러 번 풀어보면서 풀이에 적용된 논리와 방법을 익히는 익힘 지수가 {problemSolvingIndex.exercise}인 학습자에 대해 진단하고 적절한 제안을 해 줘요."</div>
                                    : <div>"100을 우수함, 80을 양호함의 기준으로 하여 수학 문제를 스마트하게 다양한 방법으로 풀어내는 문제해결능력 지수가 {problemSolvingIndex.smartness}인 학습자에 대해 진단하고 적절한 제안을 해 줘요."</div>
                        }
                    </div>
                    : null
                }
            </div>}
            <br/>
        </div>
    )
}

export default ProblemStatDescription;